import cx from "classnames";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import DSBox from "ds/components/Box";
import DeltaStrip from "components/DeltaStrip";
import State from "components/state/State";
import PerformTaskButton from "components/Run/elements/ActionButtons/PerformTaskButton";
import CopyFieldIcon from "components/CopyField/Icon";

import Icons from "./Icons";
import ListBoxLink from "./Link";
import styles from "./styles.module.css";
import { ListBoxProps, ListBoxState } from "./types";

const ListBox = (props: ListBoxProps) => {
  const {
    state,
    headerLink,
    children,
    delta,
    headerIcon,
    performAgain,
    performAgainErrorMessage,
    highlightMatches,
    className,
    innerRef,
    compact = false,
  } = props;
  const [nextUrl, setNextUrl] = useState<string | undefined>(undefined);

  if (nextUrl) {
    return <Navigate to={nextUrl} replace />;
  }

  return (
    <DSBox
      className={cx(styles.listBox, className, {
        [styles.listBoxCompact]: compact,
      })}
      ref={innerRef}
    >
      {state && (
        <div className={styles.listBoxState}>
          {state && (
            <State
              type={(state as ListBoxState).content}
              full={(state as ListBoxState).showTitle}
              text={(state as ListBoxState).text}
              link={(state as ListBoxState).link}
              isModuleVersion={(state as ListBoxState).isModuleVersion}
            />
          )}
        </div>
      )}
      <div className={styles.listBoxContent}>
        <h3
          className={cx(styles.listBoxName, {
            [styles.listBoxNameNoMargin]: headerLink.styleProps,
          })}
        >
          {headerLink.extraTitle && (
            <div className={styles.listBoxExtraTitle}>{headerLink.extraTitle}</div>
          )}
          <div className={styles.listBoxLinkWrapper}>
            <ListBoxLink
              url={headerLink.to}
              text={headerLink.name}
              routerLink={headerLink.routerLink}
              renderAsCode={headerLink.renderAsCode}
              state={headerLink.state}
              headerLink
              highlightMatches={highlightMatches}
            />
            {headerLink.canCopyName && <CopyFieldIcon title="Copy" value={headerLink.name} />}
          </div>

          <Icons headerIcon={headerIcon} />
        </h3>
        {children}
      </div>
      {delta && <DeltaStrip {...delta} />}
      {(performAgain || performAgainErrorMessage) && (
        <DSBox align="center" padding="x-large">
          <PerformTaskButton
            variant="secondary"
            stackId={performAgain?.stackId}
            command={performAgain?.command}
            tooltip={performAgainErrorMessage}
            disabled={!!performAgainErrorMessage}
            setNextUrl={setNextUrl}
          >
            Perform again
          </PerformTaskButton>
        </DSBox>
      )}
    </DSBox>
  );
};

export default ListBox;
